/**
 * 检测当前是否为 iPhone 环境（包括iPad/iPod）
 *
 * 判断逻辑：
 * 1. 检查移动设备标识
 *    - iPhone
 *    - iPad
 *    - iPod
 *
 * @returns {boolean} 如果是 iPhone/iPad/iPod 环境返回 true，否则返回 false
 *
 * @example
 * ```ts
 * if (isIPhone()) {
 *   useIPhoneNativeAPI();
 * }
 * ```
 */
export function isIPhone(): boolean {
  try {
    if (typeof navigator === "undefined" || !navigator.userAgent) {
      return false;
    }

    const ua = navigator.userAgent.toLowerCase();

    // iOS 移动设备标识
    const mobileIdentifiers = ["iphone", "ipad", "ipod"];

    return mobileIdentifiers.some((keyword) => ua.includes(keyword));
  } catch (error) {
    console.warn("检测iPhone环境失败:", error);
    return false;
  }
}
